import React, { useState } from "react";
import { useAuth } from "../auth/AuthContext";
import "./Sidebar.css";

const Sidebar = ({ onLogout }) => {
  const [isAdminMenuOpen, setIsAdminMenuOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { user } = useAuth();

  const toggleAdminMenu = () => {
    setIsAdminMenuOpen(!isAdminMenuOpen);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const menuItems = [
    {
      title: "Главная",
      path: "/",
      icon: "🏠",
    },
    {
      title: "Контакт-лист",
      path: "/contacts",
      icon: "📋",
    },
    {
      title: "Аккаунты",
      path: "/accounts",
      icon: "👥",
      submenu: [
        { title: "Новые", path: "/accounts/new" },
        { title: "Продление", path: "/accounts/renew" },
        { title: "Утерянные", path: "/accounts/lost" },
      ],
    },
    {
      title: "Агенты",
      path: "/agents",
      icon: "🤝",
    },
    {
      title: "Поддержка",
      path: "/support",
      icon: "🛠️",
    },
  ];

  const adminMenuItems = [
    { title: "Пользователи", path: "/admin/users" },
    { title: "Настройки", path: "/admin/settings" },
    { title: "Контрагенты", path: "/admin/contractors" },
    { title: "Отладка", path: "/admin/debug" },
  ];

  return (
    <>
      {/* Mobile menu button */}
      <button className="mobile-menu-button" onClick={toggleMobileMenu}>
        ☰
      </button>

      {/* Sidebar */}
      <div className={`sidebar ${isMobileMenuOpen ? "mobile-open" : ""}`}>
        <div className="sidebar-header">
          <h3>LX FBC</h3>
          <div className="user-info">
            {user?.name || user?.email || "Пользователь"}
          </div>
        </div>

        <nav className="sidebar-nav">
          {menuItems.map((item, index) => (
            <div key={index} className="nav-item">
              <a href={item.path} className="nav-link">
                <span className="nav-icon">{item.icon}</span>
                {item.title}
              </a>
              {item.submenu && (
                <div className="submenu">
                  {item.submenu.map((subItem, subIndex) => (
                    <a
                      key={subIndex}
                      href={subItem.path}
                      className="nav-link submenu-link"
                    >
                      {subItem.title}
                    </a>
                  ))}
                </div>
              )}
            </div>
          ))}

          {/* Admin menu */}
          {user?.role === "admin" && (
            <div className="nav-item">
              <button
                className="nav-link admin-toggle"
                onClick={toggleAdminMenu}
              >
                <span className="nav-icon">⚙️</span>
                Админ
                <span className={`arrow ${isAdminMenuOpen ? "open" : ""}`}>
                  ▼
                </span>
              </button>
              {isAdminMenuOpen && (
                <div className="submenu">
                  {adminMenuItems.map((item, index) => (
                    <a
                      key={index}
                      href={item.path}
                      className="nav-link submenu-link"
                    >
                      {item.title}
                    </a>
                  ))}
                </div>
              )}
            </div>
          )}
        </nav>

        <div className="sidebar-footer">
          <button className="logout-button" onClick={onLogout}>
            🚪 Выход
          </button>
        </div>
      </div>

      {/* Mobile overlay */}
      {isMobileMenuOpen && (
        <div className="mobile-overlay" onClick={toggleMobileMenu} />
      )}
    </>
  );
};

export default Sidebar;
